module.exports = __webpack_public_path__ + "img/RRC.6d37f630.svg";